import React from "react";
import Pages_Coming_Soon from "../../../OpenAccess/ComingSoon/Pages_Coming_Soon";

const Bess = () => {
  // eslint-disable-next-line react/jsx-pascal-case
  return <Pages_Coming_Soon />;
};

export default Bess;
